import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { Message } from 'primereact/message';
import { Captcha } from 'primereact/captcha';
import { Growl } from 'primereact/growl';

import servicioObjetos from '../servicio/ServicioObjetos';
import servicioHttp from '../servicio/ServicioHttp';

export class CambioContrasena extends Component {

	constructor(props) {
		super(props);
		this.state = {
			usuario: {},
			errores: {},
			mostrarContrasenas: false,
			verificaCapchap: false,
			cadenaSolicitudCambiopwd: null
		};
		this.obtenerParametros();
	}
	obtenerParametros = () => {
		let { id } = this.props.match.params;
		if (servicioObjetos.esObjetoVacio(id)) {
			window.location = "/idsenube";
		}
		servicioHttp.consumirPostHttp('usuario/contrasena/validar_vigencia.json', { cadenaSolicitudCambiopwd: id }).then(response => {
			if (response.data.error)
				window.location = "/idsenube";
		}).catch(error => {
		});
	}

	asignarDatos = (event, mayusculas) => {
		servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
	} 

	mostrarContrasena() {
		var contrasena = document.getElementById("contrasena");
		var confirmarContrasena = document.getElementById("usuario.confirmacontrasena");
		if (contrasena.type === "password" && confirmarContrasena.type === "password") {
			contrasena.type = "text";
			confirmarContrasena.type = "text";
		} else {
			contrasena.type = "password";
			confirmarContrasena.type = "password";
		}
	}

	cambiarContrasena = () => {
		let { usuario, tokenCaptcha } = this.state;
		let validacion = this.validarForm(usuario);
		this.setState({ errores: validacion });
		if (servicioObjetos.esObjetoVacio(validacion)) {
			let { id } = this.props.match.params;
			usuario.token = tokenCaptcha;
			usuario.cadenaSolicitudCambiopwd = id;
			servicioHttp
				.consumirPostHttp('/usuario/contrasena/actualizar.json', usuario)
				.then((response) => {
					this.growl.show({ severity: response.data.error === false ? "success" : "error", summary: "", detail: response.data.mensaje, life: 10000 });
					if (response.data.error) {
						this.expireCaptcha();
					} else {
						this.setState({ usuario: {}, errores: {} });
						setTimeout(function () {
							window.location = "/idsenube";
						}, 3500);
					}
				}).catch((e) => {

				});
		}
	}

	respuestaCaptcha = (response) => {
		this.setState({
			tokenCaptcha: response.response
		});
	}

	expireCaptcha = () => {
		this.setState({ tokenCaptcha: null });
		this.captcha.reset();
	}

	validarForm = (usuario) => {
		const errores = {};
		let { tokenCaptcha } = this.state;
		if (servicioObjetos.esObjetoVacio(tokenCaptcha))
			errores.captcha = 'Debe de resolver el captcha';
		if (!usuario.contrasena)
			errores.contrasena = "La contraseña es requerida";
		if (!usuario.confirmacontrasena)
			errores.confirmacontrasena = "La confirmación de contraseña es requerida";
		if (usuario.contrasena !== usuario.confirmacontrasena)
			errores.confirmacontrasena = "Las contraseñas no coinciden";
		return errores;
	};


	render() {
		let { usuario, errores } = this.state;

		return <div className="login-body">
			<Growl ref={(el) => (this.growl = el)} />
			<div className="login-type">
				<div className="card login-panel p-fluid">
					<div className="p-col-12">
						<img src="assets/layout/images/logo-ultima.svg" alt="ultima" />
					</div>
					<h4>Recuperar contraseña</h4>
					<div className="p-col-12">
						<div className="p-col-12 p-md-12">
							<span className="md-inputfield">
								<Password ref={el => this.password = el} id="contrasena" name="usuario.contrasena" value={usuario.contrasena || ""} className={errores.contrasena ? "p-error" : ""} onChange={(e) => { this.asignarDatos(e, false) }} style={{ width: '100%' }}
									promptLabel="Por favor ingresa una contraseña" weakLabel="Contraseña débil" mediumLabel="Contraseña insegura" strongLabel="Contraseña segura" />
								<label>* Nueva Contraseña</label>
								{errores.contrasena ? <div> <Message severity="error" text={errores.contrasena} /> </div> : null}
							</span>
						</div>
						<div className="p-col-12 p-md-12">
							<span className="md-inputfield">
								<Password ref={el => this.passwordConfirmacion = el} id="usuario.confirmacontrasena" name="usuario.confirmacontrasena" value={usuario.confirmacontrasena || ""} className={errores.confirmacontrasena ? "p-error" : ""} onChange={(e) => { this.asignarDatos(e, false) }} style={{ width: '100%' }}
									promptLabel="Por favor confirma la contraseña" weakLabel="Contraseña débil" mediumLabel="Contraseña insegura" strongLabel="Contraseña segura" />
								<label>* Confirma Contraseña</label>
								{errores.confirmacontrasena ? <div> <Message severity="error" text={errores.confirmacontrasena} /> </div> : null}
							</span>
						</div>
						<div className="p-col-12 p-md-3">
							<Button onClick={this.mostrarContrasena} icon="pi-md-remove-red-eye" />
						</div>
						<div className={errores.captcha ? 'p-col-12 p-md-12 p-error' : 'p-col-12 p-md-12'}>
							<Captcha ref={(r) => this.captcha = r} siteKey="6Lc5NNIZAAAAAE516_ffb7LZRGAsD6WysJ0YJhOQ" onResponse={this.respuestaCaptcha} onExpire={this.expireCaptcha} language="es"></Captcha>
							{errores.captcha ? <div><Message severity="error" text={errores.captcha} /> </div> : null}
						</div>
					</div>
					<Button label="Cambiar contraseña" icon="pi-md-edit" onClick={this.cambiarContrasena} />
				</div>
			</div>
			<div className="login-footer">Idse Nube</div>
		</div>
	}
}